// src/components/modules/entertainment.js

import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';

const Entertainment = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleVisibility = () => {
    setIsExpanded(!isExpanded);
  };

  const isNetflixAppInstalled = () => {
    const userAgent = navigator.userAgent;
  
    // Check if the device is mobile and the user agent string contains "Netflix"
    if (isMobile && userAgent.includes("Netflix")) {
      return true; // Netflix app is installed
    }
  
    return false; // Netflix app is not installed
  };

  const handleNetflixDeepLink = () => {
    const netflixDeepLink = "netflix://"; // Replace with the actual deep link URL scheme used by Netflix
  
    // Check if the Netflix app is installed
    const isNetflixAppInstalled = /* Add logic to check if the Netflix app is installed */true;
  
    // If Netflix app is installed, open the app with the deep link
    if (isNetflixAppInstalled) {
      window.location.href = netflixDeepLink;
    } else {
      // Redirect to the Netflix website
      window.location.href = "https://www.netflix.com/";
    }
  };
  return (
    <div class={isExpanded ? 'container-expanded' : 'container'}>
      <button className={isExpanded ? 'expand-btn expanded' : 'expand-btn'} onClick={toggleVisibility}>
        {isExpanded ? 'Entertainment' : 'Entertainment'}
      </button>
      {isExpanded && (
        <ul>
          <li><a translate="no" href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">YouTube</a></li>
          <li><a translate="no" href="https://www.netflix.com" target="_blank" rel="noopener noreferrer">Netflix</a></li>
          <li><a translate="no" href="netflix://" target="_blank" rel="noopener noreferrer">Netflix Android</a></li>
          <li><a translate="no" href={isNetflixAppInstalled() ? "netflix://" : "https://www.netflix.com"} target="_blank" rel="noopener noreferrer">Netflix DeepLink Test</a></li>
          <li><a translate="no" href="https://www.spotify.com" target="_blank" rel="noopener noreferrer">Spotify</a></li>
          <li><a translate="no" href="https://www.imdb.com" target="_blank" rel="noopener noreferrer">IMDB</a></li>
          <li><a translate="no" href="https://www.ign.com" target="_blank" rel="noopener noreferrer">IGN</a></li>
          <li><a translate="no" href="https://www.vulture.com" target="_blank" rel="noopener noreferrer">Vulture</a></li>
          <li><a translate="no" href="https://www.reddit.com" target="_blank" rel="noopener noreferrer">Reddit</a></li>
        </ul>
      )}
    </div>
  );
}

export default Entertainment;